import axios from 'axios';
import { auth } from '../config/firebase';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Function to get fresh token
const getFreshToken = async () => {
  const user = auth.currentUser;
  if (user) {
    try {
      const token = await user.getIdToken(true); // Force refresh
      localStorage.setItem('firebaseToken', token);
      return token;
    } catch (error) {
      return null;
    }
  }
  return null;
};

// Add auth token to requests
api.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem('firebaseToken');
    if (!token) {
      token = await getFreshToken();
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Don't set Content-Type for FormData - let axios handle it
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
      // Ensure Authorization header is still set for FormData
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;


    // Check if error is due to token expiration
    if (error.response?.status === 401 || error.response?.status === 403) {
      const errorMessage = error.response?.data?.error || error.response?.data?.detail || '';
      
      if (errorMessage.includes('Token expired') || errorMessage.includes('Invalid token')) {
        // Try to refresh the token
        const newToken = await getFreshToken();
        
        if (newToken && !originalRequest._retry) {
          originalRequest._retry = true;
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        } else {
          // Token refresh failed, redirect to login
          localStorage.removeItem('firebaseToken');
          window.location.href = '/login';
          return Promise.reject(error);
        }
      }
    }

    return Promise.reject(error);
  }
);

// Update token when user logs in
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('firebaseToken', token);
  } else {
    localStorage.removeItem('firebaseToken');
  }
};

export default api;
